import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null || isNaN(+value)) {
      return value?.toString() || '';
    }
    return (+value).toLocaleString('en-US', { 
      maximumFractionDigits: 20, 
      minimumFractionDigits: 0   
    });
  }
}
